import * as React from 'react';

import { Responsive } from '@cian/ui-kit';
import { Text as TextUIKit } from '@cian/ui-kit/prev/text';
import { FONT_DESKTOP_MAPPER, FONT_MOBILE_MAPPER, COLOR_MAPPER } from './mappers';

export type TSize = 'h1' | 'h2' | 'h3' | 'h4' | 'default' | 'small' | 'verySmall';
export type TColor = 'white' | 'black' | 'gray' | 'blue';

export interface IText {
  children: React.ReactNode;
  size?: TSize;
  color?: TColor;
  bold?: boolean;
  block?: boolean;
}

export function Text({ children, size = 'default', color = 'black', bold, block }: IText) {
  return (
    <>
      <Responsive desktop>
        <TextUIKit
          styles={{
            ...FONT_DESKTOP_MAPPER[size],
            ...COLOR_MAPPER[color],
            ...(bold ? { fontWeight: 'bold' } : {}),
            ...(block ? { display: 'block' } : {}),
          }}
        >
          {children}
        </TextUIKit>
      </Responsive>

      <Responsive tablet phone>
        <TextUIKit
          styles={{
            ...FONT_MOBILE_MAPPER[size],
            ...COLOR_MAPPER[color],
            ...(bold ? { fontWeight: 'bold' } : {}),
            ...(block ? { display: 'block' } : {}),
          }}
        >
          {children}
        </TextUIKit>
      </Responsive>
    </>
  );
}
